import React, { Component } from 'react'

export class ProjectItem extends Component {

  render() {
    return (
      <div className="row animated" data-key={this.props.id}>
        <div className="col s12 m6">
          <div className="card">
            <div className="card-image">
            <a rel="noopener noreferrer" target="_blank" href={this.props.url}><img className="project-image" alt={`Project ${this.props.id}`} src={this.props.imagePath}/></a>
            </div>
            <div className="card-content gray-text">
              <span className="card-title gray-text project-title small-text">{this.props.name}</span>
              <p>{this.props.description}</p>
            </div>
            <div className="card-action">
              <a rel="noopener noreferrer" target="_blank" href={this.props.url} className="blue-text">Go to site</a>
              <a rel="noopener noreferrer" target="_blank" href={this.props.github} className="blue-text">Github</a>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProjectItem
